module.exports = __webpack_public_path__ + "img/signup.decee31d.png";